// @flow
import { Button, Icon } from 'primitive-components';
import { colors } from 'bench-style-constants';
import React from 'react';
import styled from 'styled-components';

const ErrorMessageLayout = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-weight: 300;
  height: 100%;
  justify-content: center;
  margin: 10px;
  min-height: ${({ minHeight }) => minHeight}px;
  text-align: center;
`;

const ErrorMessageIcon = styled(Icon)`
  fill: ${colors.dust};
  height: 32px;
  width: 32px;
`;

const ErrorMessageText = styled.div`
  color: ${colors.dust};
  font-size: 16px;
  line-height: 24px;
  max-width: 350px;
  padding-top: 4px;
`;

const ErrorMessageButton = styled(Button)`
  background: none;
  color: ${colors.water};
  font-weight: 600;
  outline: none;
  padding: 8px;
  text-decoration: underline;
`;

type ErrorMessageProps = {
  minHeight: number,
  message: string,
  onRetry?: any => any,
};

/**
 * The ErrorMessage component represents a formatted error message to be shown in place of a
 * presentational component in a container component whose query failed. I can optionally show a
 * "Try Again" button, which, when clicked, could try to fetch the query again.
 */
const ErrorMessage = ({ minHeight, message, onRetry }: ErrorMessageProps) => (
  <ErrorMessageLayout minHeight={minHeight}>
    <ErrorMessageIcon icon="bell" />
    <ErrorMessageText>{message}</ErrorMessageText>
    {typeof onRetry === 'function' && (
      <ErrorMessageButton onClick={() => onRetry()}>Try Again</ErrorMessageButton>
    )}
  </ErrorMessageLayout>
);

ErrorMessage.defaultProps = {
  onRetry: undefined,
};

export default ErrorMessage;
